import {
  LanguageOption,
  NavDropdownItem,
  NavItem,
  UseNavDataProps,
} from 'components/main-nav-bar/types'
import { useState, useEffect } from 'react'

export const useNavData = ({
  navItemsProp,
  mobileMenuItemsProp,
  newsDropdownItemsProp,
  showLanguageHeader,
  languageMessageProp,
  updateTextProp,
  currentLanguageProp,
  languagesProp,
  bannerTextProp,
}: UseNavDataProps) => {
  const [parsedNavItems, setParsedNavItems] = useState<NavItem[]>([])
  const [parsedMobileMenuItems, setParsedMobileMenuItems] = useState<NavItem[]>([])
  const [shouldShowLanguageHeaderState, setShouldShowLanguageHeaderState] = useState(false)
  const [languageHeaderMessage, setLanguageHeaderMessage] = useState('')
  const [headerCtaText, setHeaderCtaText] = useState('')
  const [currentLanguageState, setCurrentLanguage] = useState<LanguageOption | null>(null)
  const [languagesList, setLanguagesList] = useState<LanguageOption[]>([])
  const [bannerTextState, setBannerText] = useState('')
  const [newsDropdownItemsState, setNewsDropdownItems] = useState<NavDropdownItem[]>([])

  useEffect(() => {
    const loadNavigationData = () => {
      try {
        if (navItemsProp) setParsedNavItems(JSON.parse(navItemsProp))
        else console.warn('MainNavbar: navItems prop is missing or empty.')
      } catch (error) {
        console.error('MainNavbar: Failed to parse navItems.', error, navItemsProp)
      }

      try {
        if (mobileMenuItemsProp) setParsedMobileMenuItems(JSON.parse(mobileMenuItemsProp))
        else console.warn('MainNavbar: mobileMenuItems prop is missing or empty.')
      } catch (error) {
        console.error('MainNavbar: Failed to parse mobileMenuItems.', error, mobileMenuItemsProp)
      }

      try {
        if (newsDropdownItemsProp) setNewsDropdownItems(JSON.parse(newsDropdownItemsProp))
        else console.warn('MainNavbar: newsDropdownItems prop is missing or empty.')
      } catch (error) {
        console.error(
          'MainNavbar: Failed to parse newsDropdownItems.',
          error,
          newsDropdownItemsProp
        )
      }

      try {
        if (currentLanguageProp) setCurrentLanguage(JSON.parse(currentLanguageProp))
        else console.warn('MainNavbar: currentLanguage prop is missing or empty.')
      } catch (error) {
        console.error('MainNavbar: Failed to parse currentLanguage.', error, currentLanguageProp)
      }

      try {
        if (languagesProp) setLanguagesList(JSON.parse(languagesProp))
        else console.warn('MainNavbar: languages prop is missing or empty.')
      } catch (error) {
        console.error('MainNavbar: Failed to parse languages.', error, languagesProp)
      }

      const showLang = showLanguageHeader ?? false
      const closed =
        typeof window !== 'undefined'
          ? localStorage.getItem('languageHeaderClosed') === 'true'
          : false
      setShouldShowLanguageHeaderState(showLang && !closed)
      setLanguageHeaderMessage(languageMessageProp ?? '')
      setHeaderCtaText(updateTextProp ?? 'Update')
      setBannerText(bannerTextProp ?? 'Join World Tennis Number')
    }

    loadNavigationData()
  }, [
    navItemsProp,
    mobileMenuItemsProp,
    newsDropdownItemsProp,
    showLanguageHeader,
    languageMessageProp,
    updateTextProp,
    currentLanguageProp,
    languagesProp,
    bannerTextProp,
  ])

  return {
    parsedNavItems,
    parsedMobileMenuItems,
    shouldShowLanguageHeaderState,
    setShouldShowLanguageHeaderState,
    languageHeaderMessage,
    headerCtaText,
    currentLanguageState,
    languagesList,
    bannerTextState,
    newsDropdownItemsState,
  }
}
